import styled from "styled-components";
import { colors } from "../../consts";

export const RouteLink = styled.a`
  font-size: 16px;
  line-height: 24px;

  color: ${colors.RAISIN_70};

  &::after {
    content: "/";
    margin: 0 8px;

    color: ${colors.RAISIN_70};
    opacity: 1 !important;
  }
`;
